import script from "./simple-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./simple-search.vue?vue&type=script&setup=true&lang=ts"

import "./simple-search.vue?vue&type=style&index=0&id=bdba5080&lang=scss"

const __exports__ = script;

export default __exports__